<template>
  <div id="join_module">
    <div>
      <img src="../../../../static/img/join/banner_02.jpg" width="100%" alt />
    </div>
    <div class="join_jobs">
      <h2>{{jobObj.jobName}}</h2>
      <div>
        <span>{{jobObj.jobNum}}人</span>
        <span>|</span>
        <span>洛阳</span>
        <span>|</span>
        <span>{{proTime}}</span>
      </div>
      <h3>岗位职责</h3>
      <div>
        <p v-for="(ditem,index) in jobObj.jobDuty" :key="index">{{ditem.name}}</p>
      </div>
      <h3>任职要求</h3>
      <div>
        <p v-for="(ritem,index) in jobObj.jobRequire" :key="index">{{ritem.name}}</p>
      </div>
    </div>
    <div class="welfare_module">
      <join-welfare></join-welfare>
    </div>
  </div>
</template>
<script>
import { jobInfo } from '@/api/frontApi/join';
import joinWelfare from './welfare';
export default {
  data() {
    return {
      jobObj: {
        jobDuty: [],
        jobRequire: [],
        jobName: '',
        jobNum: ''
      },
      jobId: 0,
      dutyArr: [],
      requireArr: []
    };
  },
  components: {
    joinWelfare
  },
  created() {
    this.getRouterID();
    this.getJobInfo();
  },
  methods: {
    getRouterID() {
      this.proTime = this.$route.params.proTime;
      if (this.$route.params.jobId) {
        this.jobId = this.$route.params.jobId;
      } else {
        this.jobId = 0;
      }
    },
    getJobInfo() {
      jobInfo({ jobId: this.jobId }).then(res => {
        this.dutyArr = res.data.jobDuty;
        for (let q = 0; q < res.data.jobDuty.length; q++) {
          let tempObj = { name: '' };
          tempObj.name = res.data.jobDuty[q];
          this.jobObj.jobDuty.push(tempObj);
        }
        for (let w = 0; w < res.data.jobRequire.length; w++) {
          let tempObj = { name: '' };
          tempObj.name = res.data.jobRequire[w];
          this.jobObj.jobRequire.push(tempObj);
        }
        this.jobObj.jobName = res.data.jobName;
        this.jobObj.jobNum = res.data.jobNum;
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
#join_module {
  width: 100%;
  min-height: 600px;
}

.welfare_module {
  width: 100%;
}

.welfare_address {
  width: 75%;
  margin: 10px auto 0;
  max-height: 380px;

  .welfare_address_left {
    background-color: #D2EDF8;
    max-height: 380px;
    width: 99%;

    .left_cup {
      padding: 10px 15px;
    }
  }
}

.job_text {
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}

.join_jobs {
  width: 75%;
  margin: 0 auto;
  padding: 20px;

  .jb_tab {
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/views/joinus/jobInfo.vue